import { UserAction } from "actions/types/UserAction";

export const API_URL = process.env.REACT_APP_API_BASE_URL;
const recordName = "user action";

// === RESPONSE INTERFACES ===
export interface CreateUserActionResponse {
  userAction: UserAction;
}

export interface UpdateUserActionResponse {
  userAction: UserAction;
}

export interface DeleteUserActionResponse {
  success: boolean;
  message?: string;
}

export interface GetUserActionResponse {
  record: UserAction;
}

export interface GetActionsByUserResponse {
  records: UserAction[];
}

// === MAIN API OBJECT ===
export const actionAPI = {
  async CreateUserAction(formData: any): Promise<CreateUserActionResponse> {
    const response = await fetch(`${API_URL}/userActions`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`Failed to create ${recordName}!`);
    }

    const data: CreateUserActionResponse = await response.json();
    return data;
  },

  async UpdateUserAction(formData: any, actionId: string): Promise<UpdateUserActionResponse> {
    const response = await fetch(`${API_URL}/userActions/${actionId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`Failed to update ${recordName}!`);
    }

    const data: UpdateUserActionResponse = await response.json();
    return data;
  },

  async DeleteUserAction(actionId: string): Promise<DeleteUserActionResponse> {
    const response = await fetch(`${API_URL}/userActions/${actionId}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error(`Failed to delete ${recordName}!`);
    }

    const data: DeleteUserActionResponse = await response.json();
    return data;
  },

  async getUserAction(actionId: string): Promise<GetUserActionResponse> {
    const response = await fetch(`${API_URL}/userActions/${actionId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch ${recordName}!`);
    }

    const data: GetUserActionResponse = await response.json();
    return data;
  },

  async getActionsByUser(userId: string, eventId: string): Promise<GetActionsByUserResponse> {
    const response = await fetch(`${API_URL}/userActions/user/${userId}?eventId=${eventId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch a list of ${recordName}s!`);
    }

    const data: GetActionsByUserResponse = await response.json();
    return data;
  },
};
